import { Dispatch, Action } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { login } from '../../config/config'


// Action types
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const RESET_PLAN_STATE = 'RESET_PLAN_STATE'
export const LOGOUT = 'LOGOUT';


interface LoginProps {
  email: string;
  password: string;
}

interface LoginRequest extends Action<typeof LOGIN_REQUEST> { }
interface LoginSuccess extends Action<typeof LOGIN_SUCCESS> {
  payload: string;
  user: any;
 }
interface LoginFailure extends Action<typeof LOGIN_FAILURE> {
  payload: string
}

interface ResetAuthState extends Action<typeof RESET_PLAN_STATE> {}

interface Logout extends Action< typeof LOGOUT>{}


export type ActionTypes = LoginRequest | LoginSuccess | LoginFailure | ResetAuthState | Logout

const loginRequest = (): LoginRequest => ({ type: LOGIN_REQUEST });
const loginSuccess = (token: string, user:any): LoginSuccess => ({ type: LOGIN_SUCCESS , payload: token, user:user });
const loginFailure = (error: string): LoginFailure => ({ type: LOGIN_FAILURE, payload: error });
const logout = ():Logout => ({type: LOGOUT});
const resetAuthState = (): ResetAuthState => ({type:RESET_PLAN_STATE})

const logoutAction =(): ThunkAction< Promise<void> , any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(logout())
  }
}

const signIn = (data: any): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      const response = data
      if(response.status === 200){
        const data = response.data;
        dispatch(loginSuccess(data.accessToken, data.user));
      }else{
        dispatch(loginFailure(response?.message || 'Something went wrong'));
      }

    } catch (error: any) {
      console.log('error', error);
      dispatch(loginFailure(error?.response?.message || error.message || 'Something went wrong'));
    }
  };
};

const reset = (): ThunkAction< Promise<void> , any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(resetAuthState())
  }
}



const actions = {
    signIn,
    reset,
    logoutAction
}

export default actions
